export default __webpack_public_path__ + "static/icon_menu_about-1.0.0.png";